module.exports = __webpack_public_path__ + "img/1register.a831d125.png";